import { useToken } from '@ori/auth';
import { basicSwrOptions } from '@ori/checkout-utils';
import { ApiClientProvider as GlobalApiClientProvider } from '@ori/global-api-client-react';
import { ApiClientProvider as StaticApiClientProvider } from '@ori/static-api-client-react';
import type { FC, PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';

import { useConfiguration } from '../contexts/configurationContext';

const API_TIMEOUT = 10000;
const swrConfig = {
  focusThrottleInterval: 300000,
  suspense: false,
  ...basicSwrOptions,
};

export const ApiProvider: FC<PropsWithChildren> = ({ children }) => {
  const { currentLanguage, globalApiUrl, staticApiUrl, tenant } = useConfiguration();
  const { formattedToken: token } = useToken();
  const globalClientProps = { baseUrl: globalApiUrl, language: currentLanguage, tenant, timeout: API_TIMEOUT, token };
  const staticClientProps = { baseUrl: staticApiUrl, language: currentLanguage, tenant, timeout: API_TIMEOUT };

  return (
    <SWRConfig value={swrConfig}>
      <GlobalApiClientProvider {...globalClientProps}>
        <StaticApiClientProvider {...staticClientProps}>{children}</StaticApiClientProvider>
      </GlobalApiClientProvider>
    </SWRConfig>
  );
};
